import api from './api';

const huntService = {
  // Get all hunts
  getAllHunts: async (filters = {}) => {
    const response = await api.get('/api/hunts', { params: filters });
    return response.data.data;
  },

  // Get hunt by ID
  getHuntById: async (huntId) => {
    const response = await api.get(`/api/hunts/${huntId}`);
    return response.data.data;
  },

  // Create new hunt (organizer)
  createHunt: async (huntData) => {
    const response = await api.post('/api/hunts', huntData);
    return response.data.data;
  },

  // Join hunt
  joinHunt: async (huntId, teamData) => {
    const response = await api.post(`/api/hunts/${huntId}/join`, teamData);
    return response.data;
  },

  // Get hunt progress
  getHuntProgress: async (huntId, teamId) => {
    const response = await api.get(
      `/api/hunts/${huntId}/teams/${teamId}/progress`
    );
    return response.data.data;
  },

  // Get leaderboard
  getLeaderboard: async (huntId) => {
    const response = await api.get(`/api/stats/hunt/${huntId}/leaderboard`);
    return response.data.data;
  },

  // Generate clue for venue
  generateClue: async (shopInfo, difficultyLevel) => {
    const response = await api.post('/api/clue/generate-clue', {
      shop_info: shopInfo,
      difficulty_level: difficultyLevel,
    });
    return response.data;
  },

  getTeamById: async (teamId) => (await api.get(`/api/teams/${teamId}`)).data.data,
  getTeamProgress: async (teamId) => (await api.get(`/api/teams/${teamId}/progress`)).data.data,
  useHint: async (teamId, progressId) => (await api.post(`/api/teams/${teamId}/hint/${progressId}`, {})).data.data,
  getPrizes: async (huntId) => api.get(`/api/hunts/${huntId}/prizes`).then((response) => response.data),
  createPrize: async (huntId, data) => (await api.post(`/api/hunts/${huntId}/prizes`, data)).data.data,
  updatePrize: async (huntId, prizeId, data) => (await api.patch(`/api/hunts/${huntId}/prizes/${prizeId}`, data)).data.data,
  deletePrize: async (huntId, prizeId) => api.delete(`/api/hunts/${huntId}/prizes/${prizeId}`),
  getTopPlayers: async (huntId) => (await api.get(`/api/stats/hunt/${huntId}/players`)).data.data,
  getUserFavorites: async () => (await api.get('/api/users/me/favorites')).data.data,
  addFavorite: async (huntId) => api.post(`/api/users/me/favorites/${huntId}`),
  removeFavorite: async (huntId) => api.delete(`/api/users/me/favorites/${huntId}`),
  getUserHuntHistory: async () => (await api.get('/api/users/me/hunts')).data.data,
  createPaymentIntent: async (data) => (await api.post('/api/payments/intent', data)).data,
  createIdealPayment: async (data) => (await api.post('/api/payments/ideal', data)).data,
  confirmPayment: async (teamId, paymentId) => (await api.post('/api/payments/confirm', { team_id: teamId, payment_id: paymentId })).data,
  validatePromoCode: async (code, huntId, amount = 0) => (await api.post('/api/payments/promo/validate', { code, hunt_id: huntId, amount })).data,
};

export default huntService;
